import {IntrospectionType, NamedTypeNode} from 'graphql';

import {getFragmentNodeName} from 'graphql-client/AST';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {getTypesByName, typeIsAbstract} from 'graphql-client/schema/util/SchemaOps';

export default function possibleTypeNamesForFragment<T>(fragmentWrapper: FragmentWrapper<T>): Array<string> {
  const {fragment, fragmentName} = fragmentWrapper;
  return possibleTypeNamesForNodeName(getFragmentNodeName(fragment, fragmentName));
}

export function possibleTypeNamesForTypeCondition(typeCondition: NamedTypeNode): Array<string> {
  return possibleTypeNamesForNodeName(typeCondition.name.value);
}

function possibleTypeNamesForNodeName(nodeName: string): Array<string> {
  const typeDef = getTypesByName()[nodeName];
  if (!typeDef) {
    throw new Error(`Expected to find the node name ${nodeName} in the GraphQL schema.`);
  }
  return subTypeNamesForSchemaType(typeDef);
}

function subTypeNamesForSchemaType(typeDef: IntrospectionType): Array<string> {
  if (!typeIsAbstract(typeDef)) {
    return [typeDef.name];
  }

  // GraphQL doesn't supported nested unions or interfaces.
  return typeDef.possibleTypes.map((stn) => stn.name);
}
